import { useState, useEffect, useRef, Fragment } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  getAuth,
  signInWithCustomToken,
  db,
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  query,
  where,
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "../firebase";
import {
  API_URL,
  scroll,
  isFieldError,
  getValFromLS,
  setValToLS,
  fmtBytes,
} from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";
import Editor from "../components/Editor";
import Select from "../components/Select";
import Radios from "../components/Radios";
import InputFile from "../components/InputFile";
import Msg from "../components/Msg";
import Submit from "../components/Submit";
import Nav from "./Nav";

const Email = () => {
  const [user, setUser] = useState({});
  const [clones, setClones] = useState([
    {
      id: "",
      name: "--",
    },
  ]);
  const [saves, setSaves] = useState([
    {
      id: "",
      name: "--",
    },
  ]);
  const [html, setHtml] = useState("");
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({});
  const [msg, setMsg] = useState({});
  const [notice, setNotice] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });
  const [fileMsg, setFileMsg] = useState({});
  const [file, setFile] = useState(null);
  const [urls, setUrls] = useState([]);
  const [status, setStatus] = useState(5);

  /*
    0 - error
    1 - complete (uploaded)
    2 - initializing
    3 - initialized
    4 - uploading
    5 - idle
  */

  const formElement = useRef(null);
  const editorRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const init = async () => {
      const token = getValFromLS("vtoUserToken")
        ? getValFromLS("vtoUserToken")
        : "";
      const url = new URL(`${API_URL}/admin/emailCreateInit`);
      const params = {
        token,
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          setUser({ ...json.user });
          scroll();
          handleFirebAuth(json.firebToken);
        } else {
          setAlert({
            type: json.resp === 2 ? "notice" : "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotice({
        type: location.state.message.type,
        text: location.state.message.text,
      });
    }
  }, [location]);

  const handleFirebAuth = (token) => {
    const auth = getAuth();
    signInWithCustomToken(auth, token)
      .then(async (userCredential) => {
        // Signed in userCredential.user;

        let newClones = clones;
        const q1 = query(
          collection(db, "bfcEmails"),
          where("uid", "==", userCredential.user.uid)
        );
        const querySnapshot1 = await getDocs(q1);
        querySnapshot1.forEach((doc) => {
          if (doc.data().sent) {
            newClones.push({
              id: doc.id,
              name: `${doc.data().date.toDate().toDateString()}: ${
                doc.data().subject
              }`,
            });
          }
        });

        setClones([...newClones]);

        let newSaves = saves;
        const emailId = getValFromLS("emailId", true);
        if (emailId) {
          newSaves.push({
            id: emailId,
            name: `Current Session: ${emailId}`,
          });
        }

        const q2 = query(
          collection(db, "bfcEmails"),
          where("uid", "==", userCredential.user.uid)
        );
        const querySnapshot2 = await getDocs(q2);
        querySnapshot2.forEach((doc) => {
          if (!doc.data().sent && doc.id !== emailId) {
            newSaves.push({
              id: doc.id,
              name: `Unsent: ${doc.id}`,
            });
          }
        });

        setSaves([...newSaves]);
        setAlert({});
      })
      .catch((error) => {
        setAlert({
          type: "error",
          text: `Error ${error.message} (${error.code}).`,
        });
      });
  };

  const handleUpdate = (name, value) => {
    if (name === "action" && value === "new") {
      setNames((names) => ({ ...names, selected: value }));
      setHtml(
        "<p>Dear {{ fname }} {{ lname }}:</p><p>Content goes here...</p>"
      );
    } else if (
      name === "action" &&
      (value === "clone" || value === "current")
    ) {
      setNames((names) => ({ ...names, selected: value }));
      setHtml("");
    } else {
      setNames((names) => ({ ...names, [name]: value ? value : "" }));
    }
  };

  const handleFirebData = async (name, value) => {
    if (value) {
      const docRef = doc(db, "bfcEmails", value);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setHtml(docSnap.data().html);
        handleUpdate("selected", name === "sentEmailId" ? "clone" : "current");
        handleUpdate(name, value);
      }
    }
  };

  const handleInitialize = (e) => {
    //console.log(e.target.files[0]);

    if (e.target.files[0]) {
      const fileData = e.target.files[0];
      setStatus(2);
      setFileMsg({
        type: "working",
        text: "",
      });
      const reader = new FileReader();

      reader.onload = (loadEvt) => {
        if (reader.readyState === 2) {
          if (fileData.size > 1999999999) {
            setStatus(0);
            setFileMsg({
              type: "error",
              text: `File upload size limited to around 1.75 GB.`,
            });
          } else {
            setFile(fileData);
            setStatus(3);
            setFileMsg({
              type: "notice",
              text: `File initialized (${fileData.type}${
                fileData.size ? `, ${fmtBytes(fileData.size)}` : ""
              })`,
            });
          }
        }
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setStatus(4);
    setFileMsg({
      type: "working",
      text: "",
    });

    let fileName = file.name;

    const fileRef = ref(storage, `bfcFiles/${fileName}`);
    const uploadTask = await uploadBytes(fileRef, file);
    const downloadUrl = await getDownloadURL(uploadTask.ref);
    let newArray = urls;
    newArray.push(downloadUrl);
    setUrls(newArray);
    setStatus(5);
    setFileMsg({});
    formElement.current.file.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const editorHtml = editorRef.current ? editorRef.current.getContent() : "";

    const url = new URL(`${API_URL}/admin/emailCreate`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("html", editorHtml);
    data.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        let emailId = "";

        if (names.selected === "new" || names.selected === "clone") {
          const docRef = await addDoc(collection(db, "bfcEmails"), {
            sent: false,
            html: editorHtml,
            uid: user.email,
          });
          emailId = docRef.id;
        } else {
          const docRef = doc(db, "bfcEmails", names.savedEmailId);
          await updateDoc(docRef, {
            html: editorHtml,
          });
          emailId = names.savedEmailId;
        }

        setValToLS("emailId", emailId, true);
        history.push("/admin/email/send");
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <Fragment>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <Fragment>
          <div id="left-column">
            <Hdg section="Admin Create Email" />

            <p>
              Use this form to create an email to send to BFC sponsor contacts
              and/or guests.
            </p>

            {notice.type && <Notice data={notice} />}

            <div className="spacer"></div>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <div
                className="form-group radios"
                style={{ marginTop: "0", marginBottom: "15px" }}
              >
                <Radios
                  label="Select Action:"
                  reqd={true}
                  data={[
                    {
                      name: "action",
                      val: "new",
                      label: "New email from blank template",
                    },
                    {
                      name: "action",
                      val: "clone",
                      label: "Clone a previously sent email",
                    },
                    {
                      name: "action",
                      val: "current",
                      label: "Continue with a saved email",
                    },
                  ]}
                  value={""}
                  click={handleUpdate}
                />
              </div>

              {names.selected === "clone" && (
                <div className="form-group">
                  <Select
                    name="sentEmailId"
                    label="Select Sent Email"
                    reqd={true}
                    value={""}
                    options={clones}
                    update={handleFirebData}
                    error={isFieldError(errors, "sentEmailId")}
                  />
                  <div className="empty" />
                </div>
              )}

              {names.selected === "current" && (
                <div className="form-group">
                  <Select
                    name="savedEmailId"
                    label="Select Saved Email"
                    reqd={true}
                    value={""}
                    options={saves}
                    update={handleFirebData}
                    error={isFieldError(errors, "savedEmailId")}
                  />
                  <div className="empty" />
                </div>
              )}

              {names.selected && (
                <div className="form-group upload-container">
                  <InputFile
                    name="file"
                    label="Upload a File (image or document)"
                    reqd={false}
                    value={""}
                    update={handleInitialize}
                    errors={errors}
                  />

                  {fileMsg.type ? (
                    <div className="upload-status-container">
                      <Msg data={fileMsg} inline={true} />
                      {status === 3 && (
                        <button
                          type="button"
                          className="btn-alt"
                          onClick={(e) => handleUpload(e)}
                        >
                          Upload File
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="empty" />
                  )}
                </div>
              )}

              {urls.length > 0 && (
                <div className="form-group one">
                  <div>
                    <label htmlFor="url" className="control-label">
                      <span>Uploaded File Url(s)</span>
                    </label>
                    {urls.map((url, index) => {
                      return (
                        <input
                          key={index}
                          type="text"
                          value={url}
                          className="form-control"
                          readOnly={true}
                          style={{ marginTop: index === 0 ? "5px" : "7.5px" }}
                        />
                      );
                    })}
                  </div>
                </div>
              )}

              {names.selected && html && (
                <div className="form-group one">
                  <Editor
                    editorRef={editorRef}
                    label="Create Email"
                    reqd={true}
                    value={html}
                  />
                </div>
              )}

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit submit="Preview / Send Email" />
                </div>
              </div>
            </form>

            <div className="spacer"></div>
          </div>

          <div id="right-column">
            <Nav on={6} user={user} />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Email;
